/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Plan_Warmup_MinutesInputs */

const en_us2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min warm-up`)
};

const pt_br2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aquecimento de ${i?.minutes} min`)
};

const es_419_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calentamiento de ${i?.minutes} min`)
};

const pt_pt2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aquecimento de ${i?.minutes} min`)
};

const fr_fr2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échauffement de ${i?.minutes} min`)
};

const de_de2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min Aufwärmen`)
};

const it_it2_plan_warmup_minutes = /** @type {(inputs: Plan_Warmup_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min di riscaldamento`)
};

/**
* | output |
* | --- |
* | "{minutes} min warm-up" |
*
* @param {Plan_Warmup_MinutesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_warmup_minutes = /** @type {((inputs: Plan_Warmup_MinutesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Warmup_MinutesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_warmup_minutes(inputs)
	if (locale === "es-419") return es_419_plan_warmup_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_warmup_minutes(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_warmup_minutes(inputs)
	if (locale === "de-DE") return de_de2_plan_warmup_minutes(inputs)
	if (locale === "it-IT") return it_it2_plan_warmup_minutes(inputs)
	return en_us2_plan_warmup_minutes(inputs)
});
export { plan_warmup_minutes as "plan.warmup_minutes" }